<template>
  <div class="manual">
    <div class="header row items-center q-py-md bg-white">
      <q-btn @click="$router.go(-1)" flat icon="arrow_back" />
      <q-space></q-space>
      <span class="text-black text-weight-bold">INFORMAÇÕES DO PASSAGEIRO</span>
      <q-space></q-space>
    </div>
    <div style="padding: 2px 0; background: #e5e5e5"></div>

    <div class="manual__info">
      <div class="q-pb-sm" style="font-size: 16px">
        <span class="text-black text-weight-bold text-capitalize">{{ passenger.name | lowerCase }}</span>
        <div>
          <span>{{ passenger.document_type }}:&nbsp;</span>
          <span>{{ passenger.document_number }}</span>
        </div>
        <span>Poltrona: {{ passenger.seat }}</span>
        <div class="q-mt-sm" v-if="passenger.boarding_alternative" style="line-height: 1">
          <small>
            <b>Embarque alternativo:</b> <br />
            {{ cityToCamelCase(passenger.boarding_alternative) }}
          </small>
        </div>
      </div>
      <q-separator></q-separator>
      <div>
        <div class="row items-center q-py-sm">
          <i class="ri-bus-2-line q-pr-sm" style="font-size: 25px; color: #808285"></i>
          <span class="text-black text-weight-bold">CARRO {{ schedule.number_bus }}</span>
        </div>
        <div class="row items-center q-pl-xs">
          <div style="width: 10px; height: 10px; background: #616264; border-radius: 100%" class="shadow-2"></div>
          <span class="q-pl-sm" style="color: #707070">{{ cityToCamelCase(schedule.origin) }}</span>
        </div>
        <div class="row items-center q-pl-xs q-pb-xs">
          <div style="width: 10px; height: 10px; background: #20c600; border-radius: 100%" class="shadow-2"></div>
          <span class="q-pl-sm text-weight-bold" style="color: #000000">{{ cityToCamelCase(schedule.destiny) }}</span>
        </div>

        <div style="font-size: 13px; color: #7a8583; padding-left: 5px">
          <span>Saída dia&nbsp;</span>
          <span class="departure--semi-bold">{{ schedule.departure_travel | formatDate }}</span>
        </div>
        <div style="font-size: 13px; color: #7a8583; padding-left: 5px">
          <span>Saída da agência&nbsp;</span>
          <span class="departure--semi-bold">{{ schedule.departure | formatDate }}</span>
        </div>
      </div>

      <div v-show="handlerBoardingLabel !== 'Cancelar'" v-for="(p, index) in searchBabyOnSeat(passenger)" :key="index" class="info__passenger-baby">
        <q-separator class="q-mb-sm" />
        <div>
          <h4 class="passenger__name">{{ p.name | lowerCase }}</h4>

          <h4 class="passenger__document">
            <span>{{ p.document_type }}:&nbsp;</span>
            <span class="document--highlight">{{ p.document_number }}</span>
          </h4>
          <h4 class="passenger__type">
            <span>Tipo passagem:&nbsp;</span>
            <span class="document--highlight">Passe criança</span>
          </h4>
          <h4 class="passenger__type text-center q-pt-sm">
            <span>Viajando junto:&nbsp;</span>
            <q-btn-toggle
              v-model="babies[index].passenger"
              unelevated
              spread
              :toggle-color="changeColorButton(titleBoarding(babies[index].passenger))"
              :class="titleBoarding(babies[index].passenger) === 'Não informado' ? 'baby-checkbox' : ''"
              class="q-pt-sm"
              :options="[
                { label: 'Não informado', value: null },
                { label: 'Não', value: false },
                { label: 'Sim', value: p },
              ]"
            />
          </h4>
        </div>
      </div>
    </div>

    <div class="luggage q-ml-sm q-mr-sm">
      <q-list v-for="(b, index) in luggages" :key="index" class="q-pb-sm">
        <q-card class="luggage__grid items-center no-shadow" style="border-radius: 10px">
          <div>
            <i class="ri-suitcase-3-line" style="color: #004923; font-size: 28px"></i>
          </div>
          <div class="column" style="line-height: 1.2">
            <span style="color: #7a8583">Bagagem adicionada</span>
            <span style="color: #da2128">
              <span class="text-weight-bold">ETIQUETA</span>
              {{ b.number }}
            </span>
          </div>
          <div>
            <q-btn @click="removeLuggage(index, b.id)" flat icon="cancel" style="color: #808285" />
          </div>
        </q-card>
      </q-list>

      <q-card class="search__box no-box-shadow full-width" v-if="!passenger.boarding_status">
        <div class="row items-center">
          <span class="search__descript"> Cadastrar ticket de bagagem </span>
        </div>
        <div>
          <q-btn
            v-show="!passenger.boarding_status"
            @click="readQRCodeLuggage()"
            unelevated
            class="text-white full-width"
            style="background: #1e9755; padding: 3px 0"
          >
            <i class="ri-qr-code-line q-pr-sm" style="font-size: 25px"></i>
            <span class="text-weight-bold">Ler QR Code da bagagem</span>
          </q-btn>
        </div>
        <q-form class="q-pa-md" @submit="readManualLuggage()">
          <span style="color: #808285; font-weight: 600; font-size: 16px">Incluir Bagagem manualmente</span>
          <div class="qrcode__grid q-pt-md">
            <div>
              <span style="color: #808285">Empresa</span>
              <q-input required filled v-model="searchLuggage.company" placeholder="00000" mask="#####" @blur="formatCompany()" />
            </div>
            <div>
              <span style="color: #808285">Modelo</span>
              <q-input required filled v-model="searchLuggage.model" placeholder="00" />
            </div>
            <div>
              <span style="color: #808285">Série</span>
              <q-input required filled v-model="searchLuggage.serie" placeholder="0000" />
            </div>
            <div>
              <span style="color: #808285">Número</span>
              <q-input required filled v-model="searchLuggage.number" placeholder="00000000" />
            </div>
          </div>
          <div class="q-pt-lg">
            <q-btn type="submit" outline color="primary" no-caps label="Incluir bagagem" class="full-width text-weight-bold" style="font-size: 16px" />
          </div>
        </q-form>
      </q-card>
    </div>

    <div class="manual__buttons fixed-bottom">
      <q-btn padding="none" @click="goBack" class="buttons__back" flat icon="cancel" label="Cancelar" no-caps style="width: 100%" />

      <q-btn
        padding="none"
        :disable="howManyBabies > 0 && validBabiesOnBoarding && handlerBoardingLabel !== 'Cancelar'"
        :class="handlerBoardingStatus"
        :icon="handlerBoardingIcon"
        @click="handlerBoarding"
        class="buttons__handler"
        flat
        no-caps
        style="width: 100%"
      >
        <span class="text-black q-pl-sm text-weight-bold">{{ handlerBoardingLabel }}</span>
      </q-btn>
    </div>
  </div>
</template>

<script>
import { SELECTED_PASSENGER, SELECTED_SCHEDULE } from "../../variables";
import { cityToCamelCase, formatDate, getSessionStorage, clearDate, getHost } from "../../functions";

import { mutations, store } from "../../store";

export default {
  name: "Manual",

  filters: {
    formatDate,

    lowerCase(text) {
      if (!text) {
        return text;
      }

      return text.toLowerCase();
    },
  },

  mounted() {
    window.scrollTo(0, 0);
    this.schedule = getSessionStorage(SELECTED_SCHEDULE);
    this.passenger = getSessionStorage(SELECTED_PASSENGER);
    if (getSessionStorage(SELECTED_PASSENGER).luggages) {
      this.luggages = getSessionStorage(SELECTED_PASSENGER).luggages;
    }
    this.getPassengers();
    this.haveBabies();
    this.cancelBoardingBabies();
  },

  computed: {
    handlerBoardingIcon() {
      return this.passenger.boarding_status ? "cancel" : "check_circle";
    },

    handlerBoardingStatus() {
      return this.passenger.boarding_status ? "buttons__handler--cancel" : "buttons__handler--confirm";
    },

    handlerBoardingLabel() {
      return this.passenger.boarding_status ? "Cancelar embarque" : "Concluír embarque";
    },
    passengers: {
      get() {
        return store.passengers;
      },
      set(value) {
        mutations.setPassengers(value);
      },
    },
  },

  data() {
    return {
      searchLuggage: {
        company: "",
        model: "",
        serie: "",
        number: "",
      },
      uriBoarding: `${getHost()}/eucaturmobile/boarding/client`,
      howManyBabies: 0,
      validBabiesOnBoarding: false,
      schedule: {},
      passenger: {},
      babies: [
        {
          passenger: null,
        },
      ],
      luggages: [],
    };
  },

  watch: {
    babies: {
      handler() {
        for (var p of this.babies) {
          if (p.passenger === null) {
            this.validBabiesOnBoarding = true;
          } else {
            this.validBabiesOnBoarding = false;
          }
        }
      },
      deep: true,
    },
  },

  methods: {
    cityToCamelCase,

    goBack() {
      this.$router.back();
    },
    
    formatCompany() {
      if(this.searchLuggage.company.length === 1) this.searchLuggage.company = '0000'+this.searchLuggage.company;
      if(this.searchLuggage.company.length === 2) this.searchLuggage.company = '000'+this.searchLuggage.company;
      if(this.searchLuggage.company.length === 3) this.searchLuggage.company = '00'+this.searchLuggage.company;
      if(this.searchLuggage.company.length === 4) this.searchLuggage.company = '0'+this.searchLuggage.company;
    },

    async handlerBoarding() {
      if (this.searchLuggage.number !== "") {
        mutations.openAlert({
          open: true,
          message: "Adicione a bagagem antes de concluir o embarque. Clique em 'Incluir bagagem' ",
          status: 300,
        });
        return;
      }
      if (this.passenger.boarding_status) {
        if (this.howManyBabies > 0) {
          for (var b of this.babies) {
            await window.http
              .delete(this.uriBoarding, {
                ticket_id: b.passenger.ticket_id,
                boarding_id: this.schedule.id,
              })
              .then(() => {
                mutations.openAlert({
                  open: true,
                  message: `Embarque do ${p.passenger.name} cancelado`,
                  status: 400,
                });
              });
          }
        }

        await window.http
          .delete(this.uriBoarding, {
            ticket_id: this.passenger.ticket_id,
            boarding_id: this.schedule.id,
          })
          .then(() => {
            mutations.openAlert({
              open: true,
              message: "Embarque cancelado",
              status: 400,
            });
            this.goBack();
          });
      } else {
        if (this.howManyBabies > 0) {
          for (var p of this.babies) {
            if (p.passenger !== null && p.passenger !== false) {
              await window.http
                .post(this.uriBoarding, {
                  ticket_id: p.passenger.ticket_id,
                  boarding_id: this.schedule.id,
                })
                .then(() => {
                  mutations.openAlert({
                    open: true,
                    message: `Embarque do ${p.passenger.name} realizado`,
                    status: 200,
                  });
                });
            }
          }
        }

        this.passenger.boarding_status;
        await window.http
          .post(this.uriBoarding, {
            ticket_id: this.passenger.ticket_id,
            boarding_id: this.schedule.id,
            boarding_lunggages: this.luggages,
          })
          .then((r) => {
            if (r.status === 200) {
              mutations.openAlert({
                open: true,
                message: "Embarque realizado",
                status: 200,
              });
              this.$router.push("/embarque/passageiros");
            }
          })
          .catch((err) => {
            console.log(err.response);
            mutations.openAlert({
              open: true,
              message: err.response.data.message,
              status: err.response.status,
            });
          });
      }
    },

    getPassengers() {
      const departure = clearDate(this.schedule.departure);
      const departureTravel = clearDate(this.schedule.departure_travel);

      const uri =
        `${getHost()}/eucaturmobile/passengers` +
        `?code=${this.schedule.boarding_code}&line=${this.schedule.line}` +
        `&departure=${departure}&departure_travel=${departureTravel}` +
        `&direction=${this.schedule.direction}` +
        `&alternative_code=${this.schedule.boarding_alternative_code}`;

      window.http.get(uri).then((response) => {
        if (response.data.message === undefined) {
          this.passengers = response.data;
          if (response.data.luggages) {
            this.luggages = response.data.luggages;
          }
        }
      });
    },

    removeLuggage(index, id) {
      if (!id) {
        this.luggages.splice(index, 1);
        return;
      }
      window.http
        .delete(`${getHost()}/eucaturmobile/luggage/${id}`)
        .then(() => {
          this.luggages.splice(index, 1);
          mutations.openAlert({
            open: true,
            message: "Bagagem excluida com sucesso!",
            status: 200,
          });
        })
        .catch(() => {
          mutations.openAlert({
            open: true,
            message: "Não foi possivel deletar a bagagem",
            status: 400,
          });
        });
    },

    searchBabyOnSeat(passenger) {
      return this.passengers.filter((v) => v.seat === passenger.seat && v.name !== passenger.name);
    },

    titleBoarding(type) {
      if (type === null) {
        return "Não informado";
      } else if (type === false) {
        return "Não";
      } else {
        return "Sim";
      }
    },

    haveBabies() {
      var count = 0;
      for (var p of this.passengers) {
        if (this.passenger.seat === p.seat && this.passenger.name !== p.name) {
          count += 1;
        }
      }
      if (count > 0) {
        this.howManyBabies = count;
        this.validBabiesOnBoarding = true;
      }
    },

    cancelBoardingBabies() {
      if (this.howManyBabies > 0 && this.handlerBoardingLabel === "Cancelar") {
        var count = 0;
        for (var p of this.passengers) {
          if (this.passenger.seat === p.seat && this.passenger.name !== p.name) {
            this.babies[count].passenger = p;
          }
        }
      }
    },

    changeColorButton(type) {
      if (type === "Não informado") {
        return "grey";
      } else if (type === "Não") {
        return "red";
      } else {
        return "green";
      }
    },

    readManualLuggage() {
      let params = {
        company: this.searchLuggage.company,
        model: this.searchLuggage.model,
        serie: this.searchLuggage.serie,
        number: this.searchLuggage.number,
      };

      if (!this.luggages.find((v) => v.company === params.company && v.model === params.model && v.serie === params.serie && v.number === params.number)) {
        this.luggages.push(params);
      } else {
        mutations.openAlert({
          open: true,
          message: "Bagagem já adicionada",
          status: 400,
        });
      }

      this.searchLuggage = {
        company: "",
        model: "",
        serie: "",
        number: "",
      };
    },

    readQRCodeLuggage() {
      if (this.$q.platform.is.cordova) {
        window.cordova.plugins.barcodeScanner.scan(
          async (result) => {
            let data = JSON.parse(result);

            if (!result) {
              mutations.openAlert({
                open: true,
                message: "Erro na Leitura",
                status: 500,
              });
              return;
            }

            let number = data.numero;
            let serie = data.serie;
            let model = data.modelo;
            let company = data.empresa;

            let params = {
              company,
              model,
              serie,
              number,
            };

            if (!this.luggages.find((v) => v === params)) {
              this.luggages.push(params);
            } else {
              mutations.openAlert({
                open: true,
                message: "Bagagem já adicionada",
                status: 400,
              });
            }
          },
          (error) => {
            mutations.openAlert({
              open: true,
              message: error,
              status: 500,
            });
          },
          {
            preferFrontCamera: false, // iOS and Android
            showFlipCameraButton: false, // iOS and Android
            showTorchButton: true, // iOS and Android
            torchOn: false, // Android, launch with the torch switched on (if available)
            saveHistory: true, // Android, save scan history (default false)
            prompt: "Leitura de QrCode", // Android
            resultDisplayDuration: 1500, // Android, display scanned text for X ms. 0 suppresses it entirely, default 1500
            formats: "QR_CODE", // default: all but PDF_417 and RSS_EXPANDED
            orientation: "portrait", // Android only (portrait|landscape), default unset so it rotates with the device
            disableAnimations: true, // iOS
            disableSuccessBeep: true, // iOS and Android
          }
        );
      }
    },
  },
};
</script>

<style lang="scss">
@import "src/scss/mixins";
@import "src/scss/components/boarding/_search_bus";

.manual {
  background: #e5e5e5;
}

.manual__info {
  background-color: #ffffff;
  padding: 20px;
}

.info__passenger-baby {
  display: grid;

  padding: 10px 0;
  width: 100%;
  margin: auto;

  .passenger__name,
  .passenger__document {
    font-size: 16px;
    line-height: normal;
    text-transform: capitalize;

    margin: 0;
  }

  .passenger__name {
    color: #040006;
    font-weight: 600;
  }

  .passenger__type {
    font-size: 16px;
    line-height: 1.3;
    margin: 0;
    color: #040006;
    font-weight: 500;
  }

  .passenger__document {
    color: #23c400;
  }

  .document--highlight {
    font-weight: 600;
  }
}

.baby-checkbox {
  transform: scale(1);
  animation: colorchange 2s infinite;
}

@keyframes colorchange {
  0% {
    transform: scale(0.95);
    box-shadow: 0 0 0 0 rgba(0, 0, 0, 0.7);
  }

  70% {
    transform: scale(1);
    box-shadow: 0 0 0 10px rgba(0, 0, 0, 0);
  }

  100% {
    transform: scale(0.95);
    box-shadow: 0 0 0 0 rgba(0, 0, 0, 0);
  }
}

.manual__buttons {
  display: grid;
  grid-template-columns: 1fr 1fr;

  width: 100%;
  height: 60px;

  .buttons__back,
  .buttons__handler {
    background-color: #ffffff;
    border-radius: unset;
    font-size: 15px;
  }

  .buttons__back {
    color: #b30c00;
    border-right: #ecedf3 solid 1px;
    font-weight: 600;
  }

  .buttons__handler--confirm {
    color: #20c600;
  }

  .buttons__handler--cancel {
    color: #b30c00;
  }
}

.luggage {
  background: #e5e5e5;
  padding: 20px 0 100px 0;
  min-height: calc(100vh - 386px);
  height: 100%;

  .luggage__grid {
    display: grid;
    grid-template-columns: max-content 1fr max-content;
    padding: 20px;
    gap: 10px;
  }
}
.search__box {
  border-radius: initial !important;
}
</style>
